function escapeHtml() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function successBanner() {
  return "\n    <aside class=\"listing-success\" data-listing-success role=\"status\" aria-live=\"polite\">\n      <button type=\"button\" class=\"saito-icon-button close\" data-action=\"dismiss-success\" aria-label=\"Dismiss\">\n        <i class=\"fa-solid fa-xmark\" aria-hidden=\"true\"></i>\n      </button>\n      <p class=\"title\">Successful Listing!</p>\n      <p class=\"body\">Your listing is now live on the Saito Network.</p>\n      <p class=\"body\">If you'd like to modify its price, description or sales terms, you can do so at any time by opening your listing.</p>\n    </aside>\n  ";
}
function copyControl() {
  return "\n    <button type=\"button\" class=\"saito-icon-button\" data-action=\"copy-url\" title=\"Copy storefront URL\" aria-label=\"Copy storefront URL\">\n      <i class=\"fas fa-copy\" aria-hidden=\"true\"></i>\n    </button>";
}
function dashboard() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$shareUrl = _ref.shareUrl,
    shareUrl = _ref$shareUrl === void 0 ? '' : _ref$shareUrl,
    _ref$showSuccess = _ref.showSuccess,
    showSuccess = _ref$showSuccess === void 0 ? false : _ref$showSuccess;
  var url = escapeHtml(shareUrl);
  var success = showSuccess ? successBanner() : '';
  var urlRow = shareUrl ? "<div class=\"storefront-url-row\">\n          <a class=\"storefront-url\" data-storefront-url href=\"".concat(url, "\" title=\"").concat(url, "\">").concat(url, "</a>\n          ").concat(copyControl(), "\n        </div>") : '';
  return "\n    ".concat(success, "\n    <section class=\"seller-home\">\n      <h2 class=\"title\">Welcome to your Store</h2>\n      <p class=\"body\">This is the address of your Store on the Saito Network. Select an option below or use the menu to the left to manage listings and sales.</p>\n      ").concat(urlRow, "\n      <div class=\"actions\">\n        <button type=\"button\" class=\"saito-button-primary\" data-action=\"list-item\">+ Add New Listing</button>\n      </div>\n    </section>\n  ");
}
function adminDenied() {
  return "\n    <section class=\"admin-denied\" role=\"status\">\n      <p class=\"body\">Please login with the appropriate account to manage this Store.</p>\n    </section>\n  ";
}
function catalogStatus() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref2$loading = _ref2.loading,
    loading = _ref2$loading === void 0 ? true : _ref2$loading;
  return loading ? "<div class=\"storefront-status\" data-storefront-status role=\"status\" aria-live=\"polite\">\n        <div class=\"saito-spinner\" aria-hidden=\"true\"></div>\n        <p>Loading listings\u2026</p>\n      </div>" : "<div class=\"storefront-status\" data-storefront-status hidden></div>";
}
function catalog() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref3$loading = _ref3.loading,
    loading = _ref3$loading === void 0 ? true : _ref3$loading;
  return "\n    <section class=\"catalog storefront-catalog\">\n      ".concat(catalogStatus({
    loading: loading
  }), "\n      <div class=\"teasers\" aria-label=\"Creator listings\"></div>\n    </section>\n  ");
}
function adminListingsCatalog() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref4$loading = _ref4.loading,
    loading = _ref4$loading === void 0 ? true : _ref4$loading;
  return "\n    <section class=\"catalog storefront-catalog\">\n      ".concat(catalogStatus({
    loading: loading
  }), "\n      <div data-listings-table></div>\n      <div class=\"catalog-footer\" data-catalog-footer hidden></div>\n    </section>\n  ");
}
module.exports = function () {
  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref5$title = _ref5.title,
    title = _ref5$title === void 0 ? 'Your Store' : _ref5$title,
    _ref5$description = _ref5.description,
    description = _ref5$description === void 0 ? '' : _ref5$description,
    _ref5$shareUrl = _ref5.shareUrl,
    shareUrl = _ref5$shareUrl === void 0 ? '' : _ref5$shareUrl,
    _ref5$loading = _ref5.loading,
    loading = _ref5$loading === void 0 ? true : _ref5$loading,
    _ref5$isDashboard = _ref5.isDashboard,
    isDashboard = _ref5$isDashboard === void 0 ? false : _ref5$isDashboard,
    _ref5$adminSection = _ref5.adminSection,
    adminSection = _ref5$adminSection === void 0 ? 'home' : _ref5$adminSection,
    _ref5$adminDenied = _ref5.adminDenied,
    denied = _ref5$adminDenied === void 0 ? false : _ref5$adminDenied,
    _ref5$showSuccess = _ref5.showSuccess,
    showSuccess = _ref5$showSuccess === void 0 ? false : _ref5$showSuccess;
  if (denied) {
    return adminDenied();
  }
  if (isDashboard && adminSection === 'active') {
    return "\n    <div class=\"storefront-admin\">\n      ".concat(adminListingsCatalog({
      loading: loading
    }), "\n    </div>\n  ");
  }
  if (isDashboard) {
    return "\n    <div class=\"storefront-admin\">\n      ".concat(dashboard({
      shareUrl: shareUrl,
      showSuccess: showSuccess
    }), "\n    </div>\n  ");
  }
  return "\n    ".concat(catalog({
    loading: loading
  }), "\n  ");
};